import React, { Component } from "react";
import { Box, Select, MenuItem, FormControl, InputLabel, Button, Paper, Tooltip, IconButton, TextField } from "@mui/material";
import Navigationbar from '../Navigationbar';
import withNavigate from "../../Global_files/WithNavigate";
import globalVariables from "../../custom_libraries/globalVariables";
import urls from "../../custom_libraries/urls";
import { get } from '../../custom_libraries/serverRequests';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import { Timeline as VisTimeline } from 'vis-timeline/standalone';
import 'vis-timeline/styles/vis-timeline-graph2d.min.css';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import DownloadIcon from '@mui/icons-material/Download';
import ReplyIcon from '@mui/icons-material/Reply';

import DatePicker from "react-multi-date-picker";
import Backdrop from '@mui/material/Backdrop';
import WebLogo from '../../assets/Artboard 1Bonus.png';


class StreamPlayback extends Component {
  constructor(props) {
    super(props);
    this.videoRefs = [];
    this.timelineRef = React.createRef();
    this.timelineInstances = {}; // key: date string → timeline instance
    this.timelineInstance = null;
    this.playheadId = "playhead";  // keep track of marker
    this.playheadId = "global-playhead";
    this.playheadTimer = null;


    const now = new Date();
    // const todayMidnight = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0);
    const today = new Date().toISOString().split("T")[0]; // "2025-08-11"

    this.state = {
      site_list: [],
      devices: [],
      cameras: [],
      selected_site: "",
      selected_device: "",
      open_progress_bar: false,
      selected_cameras: [],
      isPlaying: false,
      selectedDate: today,
      selectedDateTime: now,
      currentVideoSeconds: 0,
      apiClipData: [], // will store clip data from API
      isFullScreen: false,
      isLoadingClips: false,
      selectedDates: [new Date()], // store Date objects (picker-friendly) for showing multiple selected dates in calendar
      calendarMonth: now.getMonth() + 1,  // 1–12 for sending the current month value by default through the date list api to highligh those dates in calender showing recording clips are available on those dates
      calendarYear: now.getFullYear(),
      reservedDates: [],  // storing list of dates of a month on which recording clips are available for the selected camera
      startTime: "00:00:00", // default start
      endTime: "23:59:00",   // default end
      storedLogo: localStorage.getItem("USER_LOGO") || null,

    };
  }

  componentDidMount() {
    this.getSitesList();
    this.initTimeline([]);
    // 👇 listen for Esc key : to escape from full screen
  document.addEventListener("keydown", this.handleKeyDown);
  }

  componentWillUnmount() {
  // 👇 cleanup
  document.removeEventListener("keydown", this.handleKeyDown);
}

  componentDidUpdate(prevProps, prevState) {
    // Rebuild timeline if clips or cameras change
    // if (
    //   prevState.apiClipData !== this.state.apiClipData ||
    //   prevState.selected_cameras !== this.state.selected_cameras ||
    //   prevState.selectedDates !== this.state.selectedDates
    // ) {
    //   this.buildTimeline();
    // }
    if (prevState.isFullScreen && !this.state.isFullScreen) {
      // just exited fullscreen → ensure timeline is initialized
      this.buildTimeline();
    }

    if (
      prevState.apiClipData !== this.state.apiClipData ||
      prevState.selected_cameras !== this.state.selected_cameras ||
      prevState.selectedDates !== this.state.selectedDates
    ) {
      this.buildTimeline();
    }
  }

  // ------------------- API helpers -------------------
  getSitesList = async () => {
    const token = localStorage.getItem(globalVariables.AUTH_TOKEN);
    const headers = { 'content-type': 'application/json', 'Authorization': `Bearer ${token}` };
    try {
      const response = await get(urls.GET_SITES_BY_USER, headers);
      if (response?.data) {
        this.setState({ site_list: response.data[0] || [] });
      }
    } catch (error) {
      console.error("Error fetching sites:", error);
    }
  };

  getDevicesListById = async (siteId) => {
    this.startLoading();
    const token = localStorage.getItem(globalVariables.AUTH_TOKEN);
    const headers = { 'content-type': 'application/json', 'Authorization': `Bearer ${token}` };
    try {
      const response = await get(urls.GET_DEVICES_BY_SITE(siteId), headers);
      this.stopLoading();
      return response?.data || [];
    } catch (error) {
      console.error("Error fetching devices:", error);
      this.stopLoading();
      return [];
    }
  };

  getCamerasListByDeviceId = async (deviceId) => {
    this.startLoading();
    const token = localStorage.getItem(globalVariables.AUTH_TOKEN);
    const headers = { 'content-type': 'application/json', 'Authorization': `Bearer ${token}` };
    try {
      const response = await get(urls.CAMERAS_BY_DEVICE(deviceId), headers);
      console.log("cameras by device---", response)
      this.stopLoading();
      return response?.data || [];
    } catch (error) {
      this.stopLoading();
      console.error("Error fetching cameras:", error);
      return [];
    }
  };

  startLoading = () => {
      console.log("startloading")
        this.setState({ open_progress_bar: true })
  }
      
  stopLoading = () => {
      this.setState({ open_progress_bar: false })
  }

  handleSiteChange = async (event) => {
    const siteId = event.target.value;
    const devices = await this.getDevicesListById(siteId);
    this.setState({
      selected_site: siteId,
      selected_device: "",
      selected_cameras: [],
      devices,
      cameras: [],
    });
  };

  handleDeviceChange = async (event) => {
    const deviceId = event.target.value;
    const cameras = await this.getCamerasListByDeviceId(deviceId);
    this.setState({
      selected_device: deviceId,
      selected_cameras: [],
      cameras,
    });
  };

  handleCameraChange = (event) => {
  const selected = event.target.value;
  if (selected.length <= 4) {
    this.setState({ selected_cameras: selected }, async () => {
      await this.loadClipsForDates();

      if (selected.length > 0) {
        const { calendarYear, calendarMonth, selected_site, selected_device } = this.state;
        let allDates = new Set();

        for (const camId of selected) {
          const dates = await this.getReservedDates(
            selected_site,
            selected_device,
            camId,
            calendarYear,
            calendarMonth
          );
          dates.forEach(d => allDates.add(d));
        }

        this.setState({ reservedDates: Array.from(allDates) });
      }
    });
  } else {
    alert("You can select a maximum of 4 cameras.");
  }
};


  handleClearUserLog = () => {
  // Clear video elements
  this.videoRefs.forEach(video => {
    if (video) {
      video.pause();
      video.removeAttribute("src");
      video.load();
    }
  });

  this.setState({
    selected_site: "",
    selected_device: "",
    selected_cameras: [],
    devices: [],
    cameras: [],
    selectedDate: new Date().toISOString().split("T")[0],
    selectedDates: [new Date()],
    selectedDateTime: new Date(),
    currentVideoSeconds: 0,
    apiClipData: [],   // clears old clips
    isPlaying: false,
  });

  // Clear timeline items as well
  // Reset timeline
  if (this.timelineInstance) {
    this.timelineInstance.destroy();   // fully cleanup vis-timeline
    this.timelineInstance = null;      // ensures fresh init
  }
};


  getCameraGridData = () => {
    const { selected_cameras, cameras } = this.state;
    return selected_cameras.map((cameraId, index) => {
      const cam = cameras.find(c => c?.id === cameraId);
      return {
        id: cameraId,
        name: cam?.camera_name || `Camera ${index + 1}`,
      };
    });
  };

  // ------------------- Video controls -------------------
  // togglePlayPause = () => { //works to play/pause all videos together.
  //   const { isPlaying } = this.state;
  //   this.videoRefs.forEach((video) => {
  //     if (video) {
  //       if (isPlaying) video.pause();
  //       else video.play().catch(err => console.warn("Play error:", err));
  //     }
  //   });
  //   this.setState({ isPlaying: !isPlaying });
  // };

//   togglePlayPause = () => { //works to play/pause all videos with same time together
//   if (this.state.isPlaying) {
//     this.stopGlobalPlayhead();
//   } else {
//     const allClips = this.state.apiClipData;
//     if (!allClips.length) return;

//     // find earliest start among selected cameras
//     const minStart = new Date(Math.min(...allClips.map(c => this.parseCameraTime(c.start_time).getTime())));
//     this.startGlobalPlayhead(minStart);
//   }
// };

// togglePlayPause — resume intelligently (only if time is inside a clip)
// togglePlayPause = () => {
//   if (this.state.isPlaying) {
//     this.stopGlobalPlayhead();
//     return;
//   }

//   const allClips = this.state.apiClipData;
//   if (!allClips || !allClips.length) return;

//   // earliest clip start
//   const minStart = new Date(Math.min(...allClips.map(c => this.parseCameraTime(c.start_time).getTime())));

//   // helper: does `time` fall inside any clip window?
//   const isTimeInAnyClip = (time) => {
//     if (!time || !(time instanceof Date) || isNaN(time.getTime())) return false;
//     const t = time.getTime();
//     return allClips.some(c => {
//       const s = this.parseCameraTime(c.start_time).getTime();
//       const e = this.parseCameraTime(c.end_time).getTime();
//       return t >= s && t <= e;
//     });
//   };

//   // prefer paused playhead if it is valid, otherwise start from earliest clip
//   const resumeCandidate = this.state.selectedDateTime;
//   const startTime = isTimeInAnyClip(resumeCandidate) ? resumeCandidate : minStart;
//   console.log("resume: startTime", startTime, "selectedDateTime", this.state.selectedDateTime, "pausedPlayheadTime", this.pausedPlayheadTime);

//   // start playhead (startGlobalPlayhead will immediately seek+play)
//   this.startGlobalPlayhead(startTime);
// };

// togglePlayPause = () => {  //final working with 1. playhead starts at the position where the video was paused, even if the new date selected and that loads new video.
//   if (this.state.isPlaying) {
//     this.stopGlobalPlayhead();
//     return;
//   }

//   const allClips = this.state.apiClipData;
//   if (!allClips || !allClips.length) return;

//   // earliest clip start
//   const minStart = new Date(
//     Math.min(...allClips.map(c => this.parseCameraTime(c.start_time).getTime()))
//   );

//   // helper: does `time` fall inside any clip window?
//   const isTimeInAnyClip = (time) => {
//     if (!time || !(time instanceof Date) || isNaN(time.getTime())) return false;
//     const t = time.getTime();
//     return allClips.some(c => {
//       const s = this.parseCameraTime(c.start_time).getTime();
//       const e = this.parseCameraTime(c.end_time).getTime();
//       return t >= s && t <= e;
//     });
//   };

//   // prefer paused playhead if it is valid, otherwise start from earliest clip
//   const resumeCandidate = this.state.selectedDateTime;
//   const startTime = isTimeInAnyClip(resumeCandidate) ? resumeCandidate : minStart;

//   console.log("resume: startTime", startTime, "selectedDateTime", this.state.selectedDateTime);

//   // start playhead (startGlobalPlayhead will immediately seek+play)
//   this.startGlobalPlayhead(startTime);

//   // 🔑 Force seek + play immediately (ensures resume works)
//   this.seekAllVideosToTime(startTime, { fromPlayhead: false });

//   this.videoRefs.forEach(videoEl => {
//     if (videoEl && videoEl.paused) {
//       videoEl.play().catch(err => console.warn("Resume error:", err));
//     }
//   });
// };

  togglePlayPause = () => { //final working with 1. playhead starts at the position where the video was paused, or if the new date (previous date) selected and that loads new video playhead starts from the start of earliest clip of earliest date
  if (this.state.isPlaying) {
    this.stopGlobalPlayhead();
    return;
  }

  const allClips = this.state.apiClipData;
  if (!allClips || !allClips.length) return;

  // 🔑 find the earliest selected date
  const earliestDate = this.state.selectedDates
    .map(d => (typeof d.toDate === "function" ? d.toDate() : new Date(d)))
    .sort((a, b) => a - b)[0]
    .toISOString()
    .split("T")[0];

  // 🔑 among all clips, pick only clips from earliestDate
  const clipsForEarliestDate = allClips.filter(c =>
    c.start_time.startsWith(earliestDate)
  );

  if (!clipsForEarliestDate.length) return;

  // 🔑 find the earliest clip across all cameras for that date
  const earliestClip = clipsForEarliestDate.sort(
    (a, b) => new Date(a.start_time) - new Date(b.start_time)
  )[0];

  const startTime = this.parseCameraTime(earliestClip.start_time);

  console.log("▶ Starting playback from:", startTime);

  // start global playhead at earliest clip
  this.startGlobalPlayhead(startTime);

  // ensure videos seek and play immediately
  this.seekAllVideosToTime(startTime, { fromPlayhead: false });

  this.videoRefs.forEach(videoEl => {
    if (videoEl && videoEl.paused) {
      videoEl.play().catch(err => console.warn("Resume error:", err));
    }
  });
};


  // skipTime = (seconds) => {
  //   this.videoRefs.forEach((video) => {
  //     if (video) {
  //       const wasPlaying = !video.paused;
  //       video.currentTime = Math.max(0, video.currentTime + seconds);
  //       if (wasPlaying) video.play().catch(err => console.warn("Resume error:", err));
  //     }
  //   });
  // };

  skipTime = (seconds) => {   //this modified function moves the timeline playhead as well when skip forward/backward button is clicked.
  const { selectedDateTime } = this.state;
  if (!selectedDateTime) return;

  // 🔑 calculate new playhead time
  const newTime = new Date(selectedDateTime.getTime() + seconds * 1000);

  // update playhead on timeline
  if (this.timelineInstance) {
    this.timelineInstance.setCustomTime(newTime, this.playheadId);
  }

  // seek all videos to newTime
  this.seekAllVideosToTime(newTime, { fromPlayhead: false });

  // update state
  this.setState({ selectedDateTime: newTime });
};


  seekVideoToTime = (hour, minute) => {
    const seconds = hour * 3600 + minute * 60;
    this.videoRefs.forEach((video) => {
      if (video) {
        video.currentTime = seconds;
        if (!video.paused) video.play().catch(() => {});
      }
    });
    // const base = new Date(this.state.selectedDate);
    const base = new Date(`${this.state.selectedDate}T00:00:00`);
    base.setHours(hour, minute, 0, 0);
    this.setState({ selectedDateTime: base, currentVideoSeconds: seconds });
  };

  handleVideoEnded = (cameraId) => {
  const clipsForCam = this.state.apiClipData
    .filter(c => c.camera_id === cameraId)
    .sort((a, b) => this.parseCameraTime(a.start_time) - this.parseCameraTime(b.start_time));

  const currentClipIndex = clipsForCam.findIndex(
    c => this.videoRefs.some(v => v?.src === c.video_url)
  );

  if (currentClipIndex !== -1 && currentClipIndex < clipsForCam.length - 1) {
    const nextClip = clipsForCam[currentClipIndex + 1];
    const camIndex = this.state.selected_cameras.findIndex(id => id === cameraId);
    if (camIndex !== -1 && this.videoRefs[camIndex]) {
      const videoEl = this.videoRefs[camIndex];
      videoEl.src = nextClip.video_url;
      videoEl.play().catch(() => {});
    }
  } else {
    this.setState({ isPlaying: false });
  }
};


  // ------------------- Timeline handling -------------------
  initTimeline = (items) => {
    if (this.timelineRef.current) {
      // const baseDate = new Date(this.state.selectedDate);
      const firstSelected = (this.state.selectedDates && this.state.selectedDates.length) ? this.state.selectedDates[0] : new Date();
      const baseDate = (firstSelected && typeof firstSelected.toDate === "function") ? firstSelected.toDate() : new Date(firstSelected);
      const startOfDay = new Date(baseDate.getFullYear(), baseDate.getMonth(), baseDate.getDate(), 0, 0, 0, 0);
      const endOfDay = new Date(baseDate.getFullYear(), baseDate.getMonth(), baseDate.getDate(), 23, 59, 59, 999);
      const options = {
        stack: false,
        zoomable: true,
        moveable: true,
        orientation: 'top',
        start: startOfDay,
        end: endOfDay,
        min: startOfDay,
        max: endOfDay,
        format: { minorLabels: { hour: 'HH:mm' }, majorLabels: { day: 'MMM DD YYYY' } }
      };

      const groups = [];
      const timeline = new VisTimeline(this.timelineRef.current, items, groups, options);

      timeline.addCustomTime(new Date(), this.playheadId);
      // timeline.setCustomTimeMarker('⏱', this.playheadId, true);  // optional marker label
      timeline.setCustomTime(new Date(), this.playheadId);  //only a vertical line as playhead icon.


      // timeline.on("select", (props) => {
      //   const clip = items.find(c => c.id === props.items[0]);
      //   if (clip) {
      //     const date = new Date(clip.start);
      //     this.seekVideoToTime(date.getHours(), date.getMinutes());
      //     const camIndex = this.state.selected_cameras.findIndex(id => id === clip.group);
      //     if (camIndex !== -1 && this.videoRefs[camIndex]) {
      //       this.videoRefs[camIndex].src = clip.video_url;
      //       this.videoRefs[camIndex].play().catch(() => {});
      //     }
      //   }
      // });

      timeline.on("click", (props) => {
        if (!props.time) return;

        // find the clicked clip
        const item = props.item && timeline.itemSet.items[props.item]; // Get clicked item data
        if (!item) return;

        const clip = items.find(c => c.id === item.id);
        if (!clip) return;

        // Calculate offset (how far into the clip user clicked)
        const clickedTime = new Date(props.time);
        // Calculate offset in seconds
        const startTime = new Date(clip.start);
        const offsetSeconds = Math.floor((clickedTime - startTime) / 1000);

        const camIndex = this.state.selected_cameras.findIndex(id => id === clip.group);
        if (camIndex !== -1 && this.videoRefs[camIndex]) {
          const videoEl = this.videoRefs[camIndex];
          videoEl.src = clip.video_url;
          videoEl.onloadedmetadata = () => {
            videoEl.currentTime = offsetSeconds >= 0 ? offsetSeconds : 0;
            videoEl.play().catch(err => console.error(err));
          };
        }
      });

      timeline.on("timechanged", (props) => {
        const newTime = props.time; // real Date object
        this.seekAllVideosToTime(newTime);
      });


      this.timelineInstance = timeline;
    }
  };


  // seekAllVideosToTime = (time, { fromPlayhead = false } = {}) => {
  //   this.state.selected_cameras.forEach((cameraId, index) => {
  //     const clipsForCam = this.state.apiClipData
  //       .filter(c => String(c.camera_id) === String(cameraId))
  //       .sort((a, b) => new Date(a.start_time) - new Date(b.start_time));

  //     const clip = clipsForCam.find(c => {
  //       const start = this.parseCameraTime(c.start_time).getTime();
  //       const end = this.parseCameraTime(c.end_time).getTime();
  //       return start <= time.getTime() && end >= time.getTime();
  //     });

  //     const videoEl = this.videoRefs[index];

  //     if (clip && videoEl) {
  //       const clipStart = this.parseCameraTime(clip.start_time).getTime();
  //       const offset = (time.getTime() - clipStart) / 1000;

  //       if (videoEl.dataset.clipId !== clip.id) {
  //         // ✅ Only load when switching to a new clip
  //         videoEl.src = clip.presigned_url;
  //         videoEl.dataset.clipId = clip.id;
  //         videoEl.onloadedmetadata = () => {
  //           videoEl.currentTime = offset >= 0 ? offset : 0;
  //           if (this.state.isPlaying) videoEl.play().catch(() => {});
  //         };
  //       } else if (!fromPlayhead) {
  //         // ✅ Seek only on user scrub
  //         videoEl.currentTime = offset >= 0 ? offset : 0;
  //       }
  //       // 🚫 Do not reset currentTime every tick → prevents flicker
  //     } else if (videoEl) {
  //       // ❌ No clip at this time → clear
  //       videoEl.pause();
  //       videoEl.removeAttribute("src");
  //       videoEl.removeAttribute("data-clip-id");
  //       videoEl.load();
  //     }
  //   });

  //   this.setState({ selectedDateTime: time });
  // };

//   seekAllVideosToTime = (time, { fromPlayhead = false } = {}) => {
//   this.state.selected_cameras.forEach((cameraId, index) => {
//     const clipsForCam = this.state.apiClipData
//       .filter(c => String(c.camera_id) === String(cameraId))
//       .sort((a, b) => new Date(a.start_time) - new Date(b.start_time));

//     const clip = clipsForCam.find(c => {
//       const start = this.parseCameraTime(c.start_time).getTime();
//       const end = this.parseCameraTime(c.end_time).getTime();
//       return start <= time.getTime() && end >= time.getTime();
//     });

//     const videoEl = this.videoRefs[index];

//     if (clip && videoEl) {
//       const clipStart = this.parseCameraTime(clip.start_time).getTime();
//       const offset = (time.getTime() - clipStart) / 1000;

//       // load clip only when entering its time window
//       if (videoEl.dataset.clipId !== String(clip.id)) {
//         videoEl.src = clip.presigned_url;
//         videoEl.dataset.clipId = clip.id;
//         videoEl.onloadedmetadata = () => {
//           videoEl.currentTime = offset >= 0 ? offset : 0;
//           if (this.state.isPlaying) videoEl.play().catch(() => {});
//         };
//       } else if (!fromPlayhead) {
//         // user scrubbing: allow seeking
//         videoEl.currentTime = offset >= 0 ? offset : 0;
//       }

//       // remove overlay
//       if (videoEl.parentNode) {
//         [...videoEl.parentNode.querySelectorAll(".no-clip-overlay")].forEach(o => o.remove());
//       }
//     } else if (videoEl) {
//   // If already marked as no-clip, skip resetting to avoid flicker
//   if (videoEl.dataset.noClip !== "true") {
//     videoEl.pause();
//     videoEl.removeAttribute("src");
//     videoEl.removeAttribute("data-clip-id");
//     videoEl.load();
//     videoEl.dataset.noClip = "true";

//     if (!videoEl.parentNode.querySelector(".no-clip-overlay")) {
//       const overlay = document.createElement("div");
//       overlay.innerText = "Not available";
//       overlay.className = "no-clip-overlay";
//       Object.assign(overlay.style, {
//         position: "absolute",
//         color: "white",
//         fontSize: "16px",
//         fontWeight: "bold",
//         top: "50%",
//         left: "50%",
//         transform: "translate(-50%, -50%)",
//         pointerEvents: "none",
//         background: "rgba(0,0,0,0.5)",
//         padding: "6px 10px",
//         borderRadius: "6px"
//       });
//       videoEl.parentNode.appendChild(overlay);
//     }
//   }
// }

//   });

//   if (!fromPlayhead) {
//     // only update state when user scrubs or clicks timeline
//     this.setState({ selectedDateTime: time });
//   }
// };

// small improvement in seekAllVideosToTime: clear "no-clip" marker when clip available
seekAllVideosToTime = (time, { fromPlayhead = false } = {}) => {
  this.state.selected_cameras.forEach((cameraId, index) => {
    const clipsForCam = this.state.apiClipData
      .filter(c => String(c.camera_id) === String(cameraId))
      .sort((a, b) => new Date(a.start_time) - new Date(b.start_time));

    const clip = clipsForCam.find(c => {
      const start = this.parseCameraTime(c.start_time).getTime();
      const end = this.parseCameraTime(c.end_time).getTime();
      return start <= time.getTime() && end >= time.getTime();
    });

    const videoEl = this.videoRefs[index];

    if (clip && videoEl) {
      // clear no-clip marker so future logic doesn't skip updates
      if (videoEl.dataset.noClip === "true") {
        delete videoEl.dataset.noClip;
      }

      const clipStart = this.parseCameraTime(clip.start_time).getTime();
      const offset = (time.getTime() - clipStart) / 1000;

      if (videoEl.dataset.clipId !== String(clip.id)) {
        videoEl.src = clip.presigned_url;
        videoEl.dataset.clipId = clip.id;
        videoEl.onloadedmetadata = () => {
          videoEl.currentTime = offset >= 0 ? offset : 0;
          // now that isPlaying was set before we called this, play() should work
          if (this.state.isPlaying) videoEl.play().catch(err => console.warn("Play error:", err));
        };
      } else if (!fromPlayhead) {
        videoEl.currentTime = offset >= 0 ? offset : 0;
      }

      // remove overlay(s) if present
      if (videoEl.parentNode) {
        [...videoEl.parentNode.querySelectorAll(".no-clip-overlay")].forEach(o => o.remove());
      }

    } else if (videoEl) {
      if (videoEl.dataset.noClip !== "true") {
        videoEl.pause();
        videoEl.removeAttribute("src");
        videoEl.removeAttribute("data-clip-id");
        videoEl.load();
        videoEl.dataset.noClip = "true";

        if (!videoEl.parentNode.querySelector(".no-clip-overlay")) {
          const overlay = document.createElement("div");
          overlay.innerText = "Not available";
          overlay.className = "no-clip-overlay";
          Object.assign(overlay.style, {
            position: "absolute",
            color: "white",
            fontSize: "16px",
            fontWeight: "bold",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            pointerEvents: "none",
            background: "rgba(0,0,0,0.5)",
            padding: "6px 10px",
            borderRadius: "6px"
          });
          videoEl.parentNode.appendChild(overlay);
        }
      }
    }
  });

  if (!fromPlayhead) {
    this.setState({ selectedDateTime: time });
  }
};

  
  buildTimeline = () => {
    const { selectedDates, apiClipData } = this.state;
    if (!selectedDates.length) return;

    const cameraList = this.getCameraGridData();
    const groups = cameraList.map(cam => ({ id: cam.id, content: cam.name }));

    let items = [];

    // Use real selected dates, sorted
    const sortedDates = [...selectedDates].sort((a, b) => a - b);

    sortedDates.forEach(date => {
      const dateStr = date.toISOString().split("T")[0];

      const clipsForDate = apiClipData.filter(c =>
        c.start_time.startsWith(dateStr)
      );

      clipsForDate.forEach((clip, idx) => {
        items.push({
          id: `${dateStr}-${idx}`,
          content: `${this.formatClipTime(clip.start_time)} → ${this.formatClipTime(clip.end_time)}`,
          start: this.parseCameraTime(clip.start_time),   // 👈 real time
          end: this.parseCameraTime(clip.end_time),       // 👈 real time
          group: clip.camera_id,
          style: "background-color: #4caf50;",
          video_url: clip.presigned_url,
        });
      });
    });

    // Timeline bounds = first selected day 00:00 → last selected day 23:59
    const min = new Date(
      sortedDates[0].getFullYear(),
      sortedDates[0].getMonth(),
      sortedDates[0].getDate(),
      0, 0, 0, 0
    );
    const max = new Date(
      sortedDates[sortedDates.length - 1].getFullYear(),
      sortedDates[sortedDates.length - 1].getMonth(),
      sortedDates[sortedDates.length - 1].getDate(),
      23, 59, 59, 999
    );

    const options = {
      stack: false,
      zoomable: true,
      moveable: true,
      orientation: "top",
      min,
      max,
      start: min,
      end: max,
      format: {
        minorLabels: { hour: "HH:mm" },     // ✅ hours when zoomed in
        majorLabels: { day: "ddd D MMM" },  // ✅ actual calendar day labels
      }
    };

    if (this.timelineInstance) {
      this.timelineInstance.setGroups(groups);
      this.timelineInstance.setItems(items);
      this.timelineInstance.setOptions(options);
    } else {
      this.initTimeline(items);
      if (this.timelineInstance) {
        this.timelineInstance.setGroups(groups);
        this.timelineInstance.setOptions(options);
      }
    }
  };

  formatClipTime = (isoString) => {
    // Always return the raw "camera time" from the backend string
    // Take the HH:mm:ss part directly
    return isoString.substring(11, 19);  // "05:52:59"
  };

  parseCameraTime = (isoString) => {
  const [datePart, timePart] = isoString.replace("Z", "").split("T"); 
  const [year, month, day] = datePart.split("-").map(Number);
  const [hour, minute, second] = timePart.split(":").map(Number);

  // Create a Date in local timezone with camera’s clock values
  return new Date(year, month - 1, day, hour, minute, second);
};



  dateStringToLocalMidnight = (yyyyMmDd) => {
    const [y, m, d] = yyyyMmDd.split('-').map(x => parseInt(x, 10));
    return new Date(y, m - 1, d, 0, 0, 0, 0);
  };

  toggleFullScreenGrid = () => {
  this.setState((prev) => ({ isFullScreen: !prev.isFullScreen }));
};

  getCameraClips = async (selected_site, selected_device, cameraIds, date, startTime, endTime) => {
    const token = localStorage.getItem(globalVariables.AUTH_TOKEN);
    const headers = { 'content-type': 'application/json', 'Authorization': `Bearer ${token}` };

    try {
      // Replace with your backend API endpoint for clips
      // Format date as yyyy-mm-dd
      // const todayDate = date || new Date().toISOString().split("T")[0]; //no more date conversion to UTC midnight
      console.log("selected info-----", selected_site, selected_device, cameraIds, date, startTime, endTime);
      // const response = await get(
      //   `https://148.251.217.173:8002/api/cloud-reserve/?site_id=${selected_site}&device_id=${selected_device}&camera_id=${cameraIds[0]}&date=${date}`,
      //   headers
      // );
      // console.log("----response----", response);
      // // return response || [];
      // // Normalize so apiClipData is always an array
      // const clips = Array.isArray(response) ? response : response?.data || [];
      // return clips;
      let allClips = [];
      for (const camId of cameraIds) {
        const response = await get(
          `https://api.eyeon8i.com/api/cloud-reserve/?site_id=${selected_site}&device_id=${selected_device}&camera_id=${camId}&date=${date}&start_time=${startTime}&end_time=${endTime}`,
          // `https://devapi.neudeep.com/api/cloud-reserve/?site_id=${selected_site}&device_id=${selected_device}&camera_id=${camId}&date=${date}&start_time=${startTime}&end_time=${endTime}`,
          headers
        );
        // Normalize so apiClipData is always an array
        const clips = Array.isArray(response) ? response : response?.data || [];
        allClips = [...allClips, ...clips];
      }
      console.log("----allClips----", allClips);
      return allClips;
    } catch (error) {
      console.error("Error fetching clips:", error);
      return [];
    }
  };

  loadClipsForDates = async () => { //for multiple date selection
    const { selected_cameras, selected_device, selected_site, selectedDates, startTime, endTime } = this.state;
    if (selected_cameras.length === 0 || selectedDates.length === 0) return;

    this.setState({ isLoadingClips: true, apiClipData: [] });

    let allClips = [];
    for (const date of selectedDates) {
      const dateStr = date.toISOString().split("T")[0];
      const clips = await this.getCameraClips(selected_site, selected_device, selected_cameras, dateStr, startTime, endTime);
      
      // Attach date info for grouping
      allClips = [...allClips, ...clips.map(c => ({ ...c, _date: dateStr }))];
    }

    this.setState({ apiClipData: allClips, isPlaying: false, isLoadingClips: false });
  };


  handleDatesChange = (dates) => {
    // Reset videos
    this.videoRefs.forEach(video => {
      if (video) {
        video.pause();
        video.removeAttribute("src");
        video.load();
      }
    });
    this.videoRefs = [];

    this.setState(
      {
        selectedDates: dates,
        apiClipData: [],
        currentVideoSeconds: 0,
      },
      this.loadClipsForDates
    );
  };


  handleKeyDown = (event) => {
    if (event.key === "Escape" && this.state.isFullScreen) {
      this.toggleFullScreenGrid();
    }
  };

  //function to create a sharable .txt file that includes video clips urls.
  // handleShareClips = () => {
  //   const { apiClipData, selectedDate, selected_site, selected_device, site_list, devices } = this.state;
  //   if (!apiClipData.length) {
  //     alert("No clips to share");
  //     return;
  //   }

  //   // Find names for site and device
  //   const siteName = site_list.find(s => s.id === selected_site)?.sitename || "Site";
  //   const deviceName = devices.find(d => d.id === selected_device)?.device_name || "Device";

  //   // Join all presigned URLs with new lines
  //   const urls = apiClipData.map(c => c.presigned_url).join("\n");

  //   // Create a Blob from the URLs
  //   const blob = new Blob([urls], { type: "text/plain;charset=utf-8" });

  //   // Sanitize names (remove spaces/special chars for safe filename)
  //   const safeSite = siteName.replace(/\s+/g, "_");
  //   const safeDevice = deviceName.replace(/\s+/g, "_");

  //   // Create file name: e.g., "clips_Site_Device_2025-09-03.txt"
  //   const fileName = `clips_${safeSite}_${safeDevice}_${selectedDate}.txt`;

  //   // Create a temporary <a> tag to trigger download
  //   const link = document.createElement("a");
  //   link.href = URL.createObjectURL(blob);
  //   // link.download = `clip_links_${selectedDate}.txt`;
  //   link.download = fileName;
  //   document.body.appendChild(link); // required for Firefox
  //   link.click();

  //   // Cleanup
  //   document.body.removeChild(link);
  //   URL.revokeObjectURL(link.href);
  // };


  handleShareClips = async () => {
    const { apiClipData, selectedDate, selected_site, selected_device, site_list, devices } = this.state;

    if (!apiClipData.length) {
      alert("No clips to share");
      return;
    }

    // Resolve site and device names (fallback to IDs if names missing)
    const siteName = site_list.find(s => s.id === selected_site)?.sitename || selected_site;
    const deviceName = devices.find(d => d.id === selected_device)?.device_name || selected_device;

    // Build text content with camera info + URLs
    const lines = apiClipData.map(c => {
      const camName = this.state.cameras.find(cam => cam.id === c.camera_id)?.camera_name || c.camera_id;
      return `${camName} → ${c.presigned_url}`;
    });

    const textToCopy = ` Date: ${selectedDate}\n Site: ${siteName}\n Device: ${deviceName}\n\n${lines.join("\n")}`;

    try {
      await navigator.clipboard.writeText(textToCopy);
      alert("✅ Clip links copied to clipboard! You can paste them anywhere.");
    } catch (err) {
      console.error("Clipboard error:", err);
      alert("❌ Failed to copy links. Please try again.");
    }
  };


  onMonthChange=(dateObj) => {
    const year = dateObj.year;
    const month = dateObj.month.number;

    this.setState({ calendarYear: year, calendarMonth: month }, async () => {
      const { selected_cameras, selected_site, selected_device } = this.state;

      if (selected_cameras.length > 0) {
        let allDates = new Set();

        for (const camId of selected_cameras) {
          const dates = await this.getReservedDates(
            selected_site,
            selected_device,
            camId,
            year,
            month
          );
          dates.forEach(d => allDates.add(d));
        }

        this.setState({ reservedDates: Array.from(allDates) });
      }
    });
  }

  getReservedDates = async (siteId, deviceId, cameraId, year, month) => {
    const token = localStorage.getItem(globalVariables.AUTH_TOKEN);
    const headers = { 'content-type': 'application/json', 'Authorization': `Bearer ${token}` };

    try {
      const response = await get(
        `https://api.eyeon8i.com/api/cloud-reserve-dates/?site_id=${siteId}&device_id=${deviceId}&camera_id=${cameraId}&date=${String(month).padStart(2,'0')}-${year}`,
        // `https://devapi.neudeep.com/api/cloud-reserve-dates/?site_id=${siteId}&device_id=${deviceId}&camera_id=${cameraId}&date=${String(month).padStart(2,'0')}-${year}`,
        headers
      );
      console.log("date's list on which clips are available---", response?.dates || []);
      return response?.dates || [];
    } catch (error) {
      console.error("Error fetching reserved dates:", error);
      return [];
    }
  };

//   startGlobalPlayhead = (startTime) => {
//   if (this.playheadTimer) clearInterval(this.playheadTimer);

//   this.setState({ isPlaying: true, selectedDateTime: startTime }, () => {
//     if (this.timelineInstance) {
//       this.timelineInstance.setCustomTime(startTime, this.playheadId);
//     }

//     this.playheadTimer = setInterval(() => {
//       this.setState(prev => {
//         const newTime = new Date(prev.selectedDateTime.getTime() + 1000);

//         if (this.timelineInstance) {
//           this.timelineInstance.setCustomTime(newTime, this.playheadId);
//         }

//         // advance videos based on playhead
//         this.seekAllVideosToTime(newTime, { fromPlayhead: true });

//         return { selectedDateTime: newTime };
//       });
//     }, 1000);
//   });
// };

// startGlobalPlayhead — set isPlaying + selectedDateTime, immediately seek/play, then start interval
startGlobalPlayhead = (startTime) => {
  if (this.playheadTimer) clearInterval(this.playheadTimer);

  // Set isPlaying true and selectedDateTime; do immediate seeking inside the callback
  this.setState({ isPlaying: true, selectedDateTime: startTime }, () => {
    if (this.timelineInstance) {
      this.timelineInstance.setCustomTime(startTime, this.playheadId);
    }

    // Immediately load the correct clips and seek to startTime.
    // `seekAllVideosToTime` knows how to load the right clip for each camera.
    this.seekAllVideosToTime(startTime, { fromPlayhead: true });

    // then advance every second
    this.playheadTimer = setInterval(() => {
      this.setState(prev => {
        const newTime = new Date(prev.selectedDateTime.getTime() + 1000);
        if (this.timelineInstance) {
          this.timelineInstance.setCustomTime(newTime, this.playheadId);
        }
        this.seekAllVideosToTime(newTime, { fromPlayhead: true });
        return { selectedDateTime: newTime };
      });
    }, 1000);
  });
};

stopGlobalPlayhead = () => {
  if (this.playheadTimer) {
    clearInterval(this.playheadTimer);
    this.playheadTimer = null;
  }

  // try to read the latest playhead from the timeline if available
  let pausedTime = this.state.selectedDateTime;
  try {
    if (this.timelineInstance && typeof this.timelineInstance.getCustomTime === "function") {
      const t = this.timelineInstance.getCustomTime(this.playheadId);
      if (t instanceof Date && !isNaN(t.getTime())) {
        pausedTime = new Date(t);
      }
    }
  } catch (e) {
    console.warn("Could not read playhead time:", e);
  }

  // save paused time explicitly
  this.pausedPlayheadTime = pausedTime;

  // pause all video elements
  this.videoRefs.forEach(videoEl => {
    if (videoEl && !videoEl.paused) {
      videoEl.pause();
    }
  });

  this.setState({ isPlaying: false, selectedDateTime: pausedTime });
};



  render() {
    const cameraList = this.getCameraGridData();
    const { apiClipData } = this.state;
    // hardcoded signed S3 URL
    // const signedUrl = "https://chm-cloud-video.s3.amazonaws.com/Device/Test/2025-07-23/Device--Test--_2025-07-23_10-55_2025-07-23_21.mp4?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIA6AIUPWCQP6ACV3TN%2F20250820%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20250820T123418Z&X-Amz-Expires=604800&X-Amz-SignedHeaders=host&X-Amz-Signature=ed98159568aaba73f6f3944c4ec4bf589e0665b5f30ba6b569794c6f0a64ffd0";
    // const signedUrl = "https://chm-cloud-video.s3.amazonaws.com/Aug11/Rule/2025-08-11/Aug11_Rule_20250811-172143.mp4?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIA6AIUPWCQP6ACV3TN%2F20250822%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20250822T083345Z&X-Amz-Expires=604800&X-Amz-SignedHeaders=host&X-Amz-Signature=2dd91f073d8b160ebef596b129da376d9f9983ee1217afa0dfd77e5bf1f862b9"

    return (
      <div style={{ height: "100vh", display: 'flex', flexDirection: 'column', }}>
        <Navigationbar style={{ flexShrink: 0 }}/>
        <Box 
          sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          backgroundColor: '#f2f2f2ff',
          ml: 13,
          height: '100vh',
          overflow:'auto' 
            }}
        >

          {/* Filters */}
          <Box component={Paper} 
            sx={{
                  display: "flex",
                  gap: 2,
                  backgroundColor: 'white',
                   height: '50px', // fixed height
                  alignItems: 'center',
                  pl: 1,
                  flexShrink: 0 // keeps height fixed
                }}>
            <FormControl size="small" sx={{ minWidth: 200 }}>
              <InputLabel>Sites</InputLabel>
              <Select value={this.state.selected_site} onChange={this.handleSiteChange}>
                {this.state.site_list.map(site => (
                  <MenuItem key={site.id} value={site.id}>{site.sitename}</MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl size="small" sx={{ minWidth: 200 }}>
              <InputLabel>Devices</InputLabel>
              <Select value={this.state.selected_device} onChange={this.handleDeviceChange}>
                {this.state.devices.map(device => (
                  <MenuItem key={device.id} value={device.id}>{device.device_name}</MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl size="small" sx={{ minWidth: 200 }}>
              <InputLabel>Cameras</InputLabel>
              <Select multiple value={this.state.selected_cameras} onChange={this.handleCameraChange} 
              renderValue={(selected) => {
                const names = selected
                  .map(id => this.state.cameras.find(c => c.id === id)?.camera_name || id)
                  .join(', ');
                return (
                  <Box sx={{ 
                    display: 'inline-block', 
                    whiteSpace: 'nowrap', 
                    overflow: 'hidden', 
                    textOverflow: 'ellipsis',
                    maxWidth: 180 // control width
                  }}>
                    {names}
                  </Box>
                );
              }}
              >
                {this.state.cameras.map(camera => (
                  <MenuItem 
                    key={camera.id} 
                    value={camera.id}
                    sx={{
                      backgroundColor: this.state.selected_cameras.includes(camera.id)
                        ? 'rgba(182, 219, 255, 1)' // light blue background
                        : 'inherit'
                    }}
                  >
                    {/* {camera.camera_name} */}
                    <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                      <span style={{ flexGrow: 1 }}>{camera.camera_name}</span>
                      {this.state.selected_cameras.includes(camera.id) && (
                        <span style={{ color: '#1976d2', marginLeft: 8 }}>✔</span>
                      )}
                    </Box>
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <Button style={{ fontSize: '12px', fontWeight: 'bold', height: "34px" }} onClick={this.handleClearUserLog}>Clear</Button>
          </Box>

          {/* Main layout */}
          {this.state.selected_cameras.length > 0 && (
            <Box 
            // sx={{flex: 1, display: 'flex', flexDirection:'column', width: '100%', height:'60', gap: 2 }}
            sx={{
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              gap: 0.5,
              overflow: 'auto',
              // height: '100%',
              // backgroundColor: '#222222ff',
              backgroundColor: '#f2f2f2',
              
            }}
            >
              
              {/* Camera Grid */}
              <Box
                sx={{
                  flexGrow: 1,
                  display: 'flex',
                  flexDirection: 'column',
                  // height: 'calc(100vh - 50px - 140px)', // 50px filter + 150px timeline
                  height: this.state.isFullScreen
                    ? 'calc(100vh - 40px)' // only filters height remains
                    : 'calc(100vh - 50px - 140px)', // filters + timeline

                  overflow: this.state.isFullScreen? 'auto': 'hidden',
                  width: '100%',
                  alignSelf: 'center',
                  backgroundColor: '#3a3a3aff',
                }}
              >
                <Box
                  sx={{
                    flexGrow: 1, // fill remaining space between filters & timeline
                    display: 'grid',
                    gridTemplateColumns:
                      cameraList.length === 1
                        ? '1fr'
                        : cameraList.length === 2
                        ? '1fr 1fr'
                        : '1fr 1fr',
                    gridTemplateRows:
                      cameraList.length <= 2
                        ? '1fr'
                        : '1fr 1fr',
                    gap: 0,
                    padding: 0,
                    margin: 0,
                    height: '100%',
                    width: '100%',
                    // backgroundColor: '#000', 
                  }}
                >
                  {cameraList.map((camera, index) => {
                    const clipsForCam = apiClipData.filter(c => String(c.camera_id) === String(camera.id));
                    return (
                    <Box
                      key={camera.id || index}
                      sx={{
                        backgroundColor: '#000',
                        overflow: 'hidden',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: 0,
                        margin: 0,
                      }}
                    >
                      {this.state.isLoadingClips ? (
                        <Box sx={{ color: '#c1e9f0ff', fontSize: '16px', fontWeight: 'bold', textAlign: 'center' }}>
                          Requesting the feed...
                        </Box>
                      ) : clipsForCam.length > 0 ? (
                      <video
                        key={`${camera.id}-${this.state.selectedDates[0]?.toISOString().split("T")[0]}`}   //  ensures reset on date change
                        preload="metadata"
                        muted playsInline
                        ref={(el) => {
                          this.videoRefs[index] = el;
                        }}
                        onEnded={() => this.handleVideoEnded(camera.id)}
                        style={{
                          width: '100%',
                          height: '100%',
                          objectFit: 'fill',
                        }}
                      >
                        
                        {/* {clipsForCam.length > 0 && (
                          <source
                            key={`${camera.id}-${this.state.selectedDate}`}
                            src={clipsForCam[0].presigned_url}
                            type="video/mp4"
                          />
                        )} */}
                        {/* if the new date (previous date) selected, below modified snippet will load new earliest clip of earliest date across all selected dates for each selected camera*/}
                        {clipsForCam.length > 0 && (() => {
                          // find the earliest selected date
                          const earliestDate = this.state.selectedDates
                            .map(d => (typeof d.toDate === "function" ? d.toDate() : new Date(d)))
                            .sort((a, b) => a - b)[0]
                            .toISOString()
                            .split("T")[0];

                          // only clips belonging to that date
                          const clipsForEarliestDate = clipsForCam.filter(c =>
                            c.start_time.startsWith(earliestDate)
                          );

                          if (!clipsForEarliestDate.length) return null;

                          // pick the earliest clip of that date
                          const earliestClip = clipsForEarliestDate.sort(
                            (a, b) => new Date(a.start_time) - new Date(b.start_time)
                          )[0];

                          return (
                            <source
                              key={`${camera.id}-${earliestDate}`}
                              src={earliestClip.presigned_url}
                              type="video/mp4"
                            />
                          );
                        })()}
                        Your browser does not support the video tag.
                      </video>
                      ) : (
                      <Box
                        sx={{
                          color: 'white',
                          fontSize: '16px',
                          fontWeight: 'bold',
                          textAlign: 'center',
                        }}
                      >
                        Not available
                      </Box>
                    )}
                    </Box>
                    );
                  })}
                </Box>
              </Box>

            {/* Timeline */}
            {!this.state.isFullScreen && (
              <Box 
              // sx={{ flex: 1, backgroundColor: '#fff', p: 1, borderRadius: 2 }}
              sx={{
                backgroundColor: '#fff',
                p: 0.5,
                // borderRadius: 2,
                // overflow: 'hidden',
                height: '150px', // fixed height
                maxHeight: '210px',//fixed height
                flexShrink: 0,
              }}
              >
                {/* Controls */}
                <Box sx={{ display: 'flex', gap: 1, mb: 0.5, flexShrink: 0, justifyContent:'center' }}>
                  <Tooltip title="-5 sec"><IconButton size="small" onClick={() => this.skipTime(-5)}>⏪</IconButton></Tooltip>
                  <Tooltip title={this.state.isPlaying ? "Pause" : "Play"}>
                    <IconButton size="small" color="primary" onClick={this.togglePlayPause}>
                      {this.state.isPlaying ? '⏸' : '▶'}
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="+5 sec"><IconButton size="small" onClick={() => this.skipTime(5)}>⏩</IconButton></Tooltip>
                  {/* <Tooltip title="Select date(s)">
                    <CalendarTodayIcon
                      onClick={() => this.nativeDateInput?.showPicker()}
                      sx={{ cursor: 'pointer', color: '#1976d2', ml: 2 }}
                      size="small"
                    />
                  </Tooltip> */}
                  {/* full screen icon */}
                  <Tooltip title={this.state.isFullScreen ? "Exit Full Screen" : "Full Screen"}>
                    <IconButton size="small" onClick={this.toggleFullScreenGrid}>
                      {this.state.isFullScreen ? <FullscreenExitIcon /> : <FullscreenIcon />}
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Download Clips">
                    <IconButton
                      size="small"
                      color="primary"
                      // onClick={() => {
                      //   const zipUrl = `https://`
                      //   + `chm-cloud-video.s3.amazonaws.com/`
                      //   + `${this.state.selectedDate.replace(/-/g, '')}/`
                      //   + `${this.state.site_list.find(s => s.id === this.state.selected_site)?.sitename || 'Site'}/`
                      //   + `${this.state.devices.find(d => d.id === this.state.selected_device)?.device_name || 'Device'}/`
                      //   + `clips_${this.state.selectedDate.replace(/-/g, '')}.zip?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIA6AIUPWCQP6ACV3TN%2F20250822%2Fap-south-1%2Fs3%2Faws4_request&X-Amz-Date=20250822T090000Z&X-Amz-Expires=604800&X-Amz-SignedHeaders=host&X-Amz-Signature=dummy-signature-for-example`;
                      //   window.open(zipUrl, '_blank');
                      // }}
                    >
                      <DownloadIcon />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Share Clips">
                    <IconButton
                      size="small"
                      color="primary"
                      onClick={this.handleShareClips}
                      >
                        <ReplyIcon color="primary" sx={{ transform: "scaleX(-1)" }}/>
                    </IconButton>
                    
                  </Tooltip>
                  {/* Hidden native date input */}

                  {/* <input
                    type="date"
                    ref={el => (this.nativeDateInput = el)}
                    value={this.state.selectedDate}
                    onChange={(e) => this.handleDateChange(e.target.value)}
                    style={{ position: 'absolute', opacity: 0, pointerEvents: 'none' }}
                  /> */}
                  <DatePicker
                    multiple
                    value={this.state.selectedDates}
                    onChange={(dates) => {
                      // Convert to JS Date objects
                      const selected = dates.map(d => (typeof d.toDate === "function" ? d.toDate() : new Date(d)));
                      this.handleDatesChange(selected);
                    }}
                    format="YYYY-MM-DD"
                    mapDays={({ date }) => {
                      const dateStr = date.format("YYYY-MM-DD");
                      if (this.state.reservedDates.includes(dateStr)) {
                        return {
                            children: (
                              <div
                                style={{
                                  position: "relative",
                                  width: "100%",       // fill the cell
                                  height: "100%",      // fill the cell
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center"
                                }}
                              >
                                <span>{date.day}</span>
                                <span
                                  style={{
                                    position: "absolute",
                                    bottom: "0px",     // adjust distance from bottom
                                    left: "4px",      // adjust distance from right
                                    width: "6px",
                                    height: "6px",
                                    borderRadius: "50%",
                                    background: "orange"
                                  }}
                                ></span>
                              </div>
                            )
                          };
                      }
                    }}
                    onMonthChange={(dateObj) => {
                      const year = dateObj.year;
                      const month = dateObj.month.number; // 1–12
                      if (this.state.selected_cameras.length > 0) {
                          const { selected_cameras, selected_site, selected_device } = this.state;
                          let allDates = new Set();

                          (async () => {
                            for (const camId of selected_cameras) {
                              const dates = await this.getReservedDates(
                                selected_site,
                                selected_device,
                                camId,
                                year,
                                month
                              );
                              dates.forEach(d => allDates.add(d));
                            }
                            this.setState({ reservedDates: Array.from(allDates) });
                          })();
                        }

                    }}
                  />
                  {/* start and end time selection boxes */}
                  <FormControl size="small">
                    <TextField
                      label="Start Time"
                      type="time"
                      value={this.state.startTime}
                      onChange={(e) => {
                        const value = e.target.value; // e.g. "10:30"
                        this.setState({ startTime: value ? `${value}:00` : "00:00:00" }, this.loadClipsForDates);
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{
                        step: 60, // ⏱ 1-minute steps, no seconds
                      }}
                      sx={{
                        "& .MuiInputBase-root": { height: 30 },   // reduce height
                        "& input": { padding: "2px 8px", fontSize:'13px' },       // reduce input padding
                      }}
                    />
                  </FormControl>

                  <FormControl size="small">
                    <TextField
                      label="End Time"
                      type="time"
                      value={this.state.endTime}
                      onChange={(e) => {
                        const value = e.target.value; 
                        this.setState({ endTime: value ? `${value}:00` : "23:59:00" }, this.loadClipsForDates);
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{
                        step: 60, // ⏱ 1-minute steps
                      }}
                      sx={{
                        "& .MuiInputBase-root": { height: 30 },   // reduce height
                        "& input": { padding: "3px 8px", fontSize:'13px' },       // reduce input padding
                      }}
                    />
                  </FormControl>

                </Box>
                <div ref={this.timelineRef} style={{flex: 1, fontSize:'12px', backgroundColor: '#fff', }}></div>
              </Box>
            )}
            </Box>
          )}
        </Box>
        {/* Backdrop with Circular Progress */}
        <Backdrop open={this.state.open_progress_bar}>
          <div className="custom-spinner">
              <div className="circle"></div>
              <div className="circle tilted"></div>
              <img src={this.state.storedLogo ? this.state.storedLogo : WebLogo} alt="web-logo" style={{backgroundColor:'#001f54', borderRadius:'100px'}}/>
          </div>
        </Backdrop>
      </div>
    );
  }
}

export default withNavigate(StreamPlayback);
